import type { FC } from 'react';
import { useState } from 'react';

import { getAnimationOffset } from './helpers';
import type { SplashScreenStyle } from './types';
import SplashAnimation from './zencargo-splash.svg?react';

const SplashScreen: FC = () => {
  const [animationOffset] = useState<string>((): string => getAnimationOffset(performance.now()));

  const style: SplashScreenStyle = { '--zs-offset': animationOffset };

  return (
    <div className="flex items-center justify-center w-screen h-screen bg-white" data-component="splash-screen" style={style}>
      <SplashAnimation aria-label="Loading" role="img" />
    </div>
  );
};

export default SplashScreen;
